import { clsx } from 'clsx'

import type {
  ExternalSearchResult,
  Member,
  Post,
  Space,
} from '@tribeplatform/gql-client/types'

import {
  ExtendedSmartSearchEntity,
  ExtendedSmartSearchEntityType,
} from '../../../SmartSearch.types.js'
import { HistoryItem } from '../../SearchHistory/SearchHistory.types.js'

interface Props {
  item: ExtendedSmartSearchEntity
  entityType: ExtendedSmartSearchEntityType
}

export const SearchEntityRowContent = ({ item, entityType }: Props) => {
  const title =
    entityType === ExtendedSmartSearchEntityType.HISTORY
      ? (item as HistoryItem).data.title
      : ((item as Post).title ?? (item as Member | Space).name)

  const description =
    entityType === ExtendedSmartSearchEntityType.HISTORY
      ? (item as HistoryItem).data.description
      : (item as Post | ExternalSearchResult)?.description
  const hasDescription = !!description

  return (
    <div className="grid gap-1 h-full sm:grid-rows-2 sm:items-center">
      <h2
        className={clsx('font-semibold line-clamp-1', {
          'row-span-2': !hasDescription,
        })}
      >
        {title}
      </h2>
      {hasDescription && (
        <span className="text-sm line-clamp-1">{description}</span>
      )}
    </div>
  )
}
